import * as React from "react";
import "./PaymentMethodsBanner.scss";

/**
 * @component
 */
export function PaymentMethodsBanner(): React.ReactElement {
  return (
    <div className={"PaymentMethodsBanner"}>
      <div className={"Svg Svg-Icon-PayPal"}>&#160;</div>
      <div className={"Svg Svg-Icon-AmazonPay"}>&#160;</div>
      <div className={"Svg Svg-Icon-CreditCart"}>&#160;</div>
      <div className={"Svg Svg-Icon-Advance"}>&#160;</div>
      <div className={"Svg Svg-Icon-Invoice"}>&#160;</div>
    </div>
  );
}
